module.exports = __webpack_public_path__ + "media/images/bus/conditions/PREF-2b51b35975fd0152ea844b450bbec965.svg";